import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useEffect, useState } from "react";

/**
 * useGetValidNodeNum - 获取用户有效直推节点数
 */
const useGetValidNodeNum = () => {
    const { address, contractEvm: { QueryFunction } } = useConnectWallet();

    // 有效直推数
    const [validNodeNum, setValidNodeNum] = useState<bigint>(BigInt(0));
    // loading
    const [validNodeNumLod, setLoading] = useState(false);

    /**
     * getValidNodeNum - 获取用户实际有效直推节点数
     */
    const getValidNodeNum = useCallback(async () => {
        if (!QueryFunction || !address) return;

        try {
            setLoading(true);

            const res = await QueryFunction.getRealValidNodeNum(address);

            setValidNodeNum(res);

        } catch (error) {
            console.log('useGetValidNodeNum error:', error);
        } finally {
            setLoading(false);
        }
    }, [QueryFunction, address]);

    useEffect(() => {
        getValidNodeNum();
    }, [getValidNodeNum]);

    return {
        validNodeNum,
        validNodeNumLod,
        getValidNodeNum
    };
};

export default useGetValidNodeNum;
